module.exports = __webpack_public_path__ + "img/angela-sung-pasadena.b6c05c3.jpg";